import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetAccessControlParams extends PaginationProps {}

interface CreateAccessControl {
  name: string;
  description: string | null;
}

interface UpdateAccessControl extends CreateAccessControl {
  id: number | null;
}

export async function getAccessControls() {
  const { data } = await api.get('/access-controls');
  return data;
}

export async function getAccessControlsMasterData(
  params: GetAccessControlParams
) {
  const { data } = await api.get('/access-controls/master-data', {
    params
  });
  return data;
}

export async function getAccessControl(id: number) {
  const { data } = await api.get(`/access-controls/${id}`);
  return data;
}

export async function createAccessControl(
  createAccessControl: CreateAccessControl
) {
  const { data } = await api.post('/access-controls', createAccessControl);
  return data;
}

export async function updateAccessControl(
  updateAccessControl: UpdateAccessControl
) {
  const { data } = await api.put(
    `/access-controls/${updateAccessControl.id}`,
    updateAccessControl
  );
  return data;
}

export function deleteAccessControl(id: number) {
  return api.delete(`/access-controls/${id}`);
}
